import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function AllSharedReport() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedReportsByUser/Report`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllReportGroups() {
    try {
        const response = await getAxiosInstance().get(`/Template/getAllReportingGroupByUser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ReportQuery(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/getDataByTemplateQuery`, payload, { headers })
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ReportSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/createCustomTemplateQuery`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ReportDetailsAPi(templateQueryId) {
    try {
        const response = await getAxiosInstance().get(`/Template/getCustomReportDetailByReportingQueryId/${templateQueryId}`, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllReportingGroupShareByUser() {
    try {
        const response = await getAxiosInstance().get(`/Template/getAllReportingGroupShareByUser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateReportingGroupShare(payload) {
    try {
        const response = await getAxiosInstance().put(`/Template/updateReportingGroupShare`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteReportingGroupShare(sharedId) {
    try {
        const data = await getAxiosInstance().delete(`/Template/deleteReportingGroupShare/${sharedId}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteCustomTemplateQuery(sharedId) {
    try {
        const data = await getAxiosInstance().delete(`/Template/deleteCustomTemplateQuery/${sharedId}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllByReportingGroupId(reportingGroupId) {
    try {
        const response = await getAxiosInstance().get(`/Template/findAllByReportingGroupId/${reportingGroupId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createReportingGroupShare(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/createReportingGroupShare`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchAllReportingGroupShare() {
    try {
        const response = await getAxiosInstance().get(`/Template/fetchAllReportingGroupShare`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getQualifiedPipelineStageValue(isQualified) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getQualifiedPipelineStageValue/${isQualified}`, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllEntityCountsByDuration(state) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/AllEntityCountsByDuration/${state}`, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getDealCountAndValueByPipeline(state) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getDealCountAndValueByPipeline/${state}`, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getTopSalesPersonnel(state) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getTopSalesPersonnel/${state}`, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllTopProductByDealOwner() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllTopProductByDealOwner`, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllByDealValuByCurrentAndPast(state) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllByDealValuByCurrentAndPast/${state}`, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    findAllByDealValuByCurrentAndPast,
    findAllTopProductByDealOwner,
    getTopSalesPersonnel,
    AllEntityCountsByDuration,
    getDealCountAndValueByPipeline,
    AllSharedReport,
    AllReportGroups,
    ReportQuery,
    ReportSave,
    ReportDetailsAPi,
    getAllReportingGroupShareByUser,
    updateReportingGroupShare,
    deleteReportingGroupShare,
    findAllByReportingGroupId,
    createReportingGroupShare,
    fetchAllReportingGroupShare,
    deleteCustomTemplateQuery,
    getQualifiedPipelineStageValue
}